import { IcoStar, IcoText } from "../../../../components/icons";
import type { QuestionType } from "../../../../types";

type QuestionTypeBadgeProps = {
  type: QuestionType;
  ratingMax: number;
};

export function QuestionTypeBadge({ type, ratingMax }: QuestionTypeBadgeProps) {
  if (type === "rating") {
    return (
      <span class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300">
        <IcoStar class="size-3" />
        1-{ratingMax}
      </span>
    );
  }
  return (
    <span class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300">
      <IcoText class="size-3" />
      Text
    </span>
  );
}
